"use strict";

var _regeneratorRuntime = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/regenerator");

require("regenerator-runtime/runtime");

var _slicedToArray = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/slicedToArray");

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  display: inline-block;\n  margin-right: ", " !important;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  margin-left: auto;\n  padding-left: ", ";\n  display: flex;\n  align-items: center;\n  > div:not(:last-child) {\n    margin-right: ", ";\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  flex-direction: row;\n  margin-bottom: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .ant-picker-calendar-date {\n    height: 200px !important;\n    cursor: default;\n    pointer-events: none;\n    background: transparent !important;\n  }\n  .ant-picker-calendar-date-value {\n    color: ", " !important;\n  }\n  .ant-picker-cell {\n    pointer-events: none;\n    cursor: default;\n  }\n  .ant-picker-calendar-date-content {\n    height: 170px !important;\n    pointer-events: all;\n    padding-bottom: ", ";\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);

  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function get() {
        return m[k];
      }
    };
  }

  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FragmentCalendarView = void 0;

var icons_1 = require("@ant-design/icons");

var antd_1 = require("antd");

var react_1 = __importStar(require("react"));

var styled_components_1 = __importDefault(require("styled-components"));

var Typography_1 = require("../Typography");

var Container = styled_components_1.default.div(_templateObject(), function (props) {
  return props.theme['@text-color-secondary'];
}, function (props) {
  return props.theme['@size-xxs'];
});
var HeaderContainer = styled_components_1.default.div(_templateObject2(), function (props) {
  return props.theme['@size-m'];
});
var HeaderRight = styled_components_1.default.div(_templateObject3(), function (props) {
  return props.theme['@size-s'];
}, function (props) {
  return props.theme['@size-xs'];
});
var SpinContainer = styled_components_1.default.div(_templateObject4(), function (props) {
  return props.theme['@size-m'];
});

function FragmentCalendarView(_ref) {
  var _this = this;

  var headerLeft = _ref.headerLeft,
      headerRight = _ref.headerRight,
      refetch = _ref.refetch,
      _loading = _ref.loading,
      monthSelected = _ref.monthSelected,
      renderCalendarDate = _ref.renderCalendarDate;

  var _ref2 = (0, react_1.useState)(false),
      _ref3 = _slicedToArray(_ref2, 2),
      stateLoading = _ref3[0],
      setLoading = _ref3[1];

  var loading = _loading || stateLoading;
  return react_1.default.createElement(Container, null, react_1.default.createElement(antd_1.Calendar, {
    onPanelChange: function onPanelChange(date) {
      return __awaiter(_this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var monthString;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(refetch || monthSelected)) {
                  _context.next = 17;
                  break;
                }

                monthString = date.clone().endOf('month').format();
                setLoading(true);
                _context.prev = 3;

                if (!refetch) {
                  _context.next = 9;
                  break;
                }

                _context.next = 7;
                return refetch(btoa("0_*_".concat(JSON.stringify(monthString))));

              case 7:
                _context.next = 12;
                break;

              case 9:
                if (!monthSelected) {
                  _context.next = 12;
                  break;
                }

                _context.next = 12;
                return monthSelected(monthString);

              case 12:
                _context.next = 16;
                break;

              case 14:
                _context.prev = 14;
                _context.t0 = _context["catch"](3);

              case 16:
                setLoading(false);

              case 17:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[3, 14]]);
      }));
    },
    dateCellRender: renderCalendarDate,
    headerRender: function headerRender(_ref4) {
      var value = _ref4.value,
          onChange = _ref4.onChange;
      var previousMonth = value.clone().subtract(1, 'month').format('MMMM YYYY');
      var nextMonth = value.clone().add(1, 'month').format('MMMM YYYY');
      var currentMonth = value.clone().format('MMMM YYYY');
      return react_1.default.createElement(HeaderContainer, null, react_1.default.createElement("div", null, headerLeft), react_1.default.createElement(HeaderRight, null, loading ? react_1.default.createElement(SpinContainer, null, react_1.default.createElement(antd_1.Spin, {
        size: 'small'
      })) : null, react_1.default.createElement(Typography_1.BodyLarge, {
        weight: Typography_1.FontWeight.Bold,
        style: {
          display: 'inline-block',
          marginRight: '1em'
        }
      }, currentMonth), react_1.default.createElement(antd_1.Button.Group, null, react_1.default.createElement(antd_1.Button, {
        icon: react_1.default.createElement(icons_1.ArrowLeftOutlined, null),
        onClick: function onClick() {
          return onChange(value.clone().subtract(1, 'month'));
        }
      }, previousMonth), react_1.default.createElement(antd_1.Button, {
        onClick: function onClick() {
          return onChange(value.clone().add(1, 'month'));
        }
      }, nextMonth, " ", react_1.default.createElement(icons_1.ArrowRightOutlined, null))), headerRight));
    }
  }));
}

exports.FragmentCalendarView = FragmentCalendarView;